import { OPEN_QUESTION_TREE_MODE, serializeQuestionTreeState } from '@/utils/openQuestionTree'

const state = {
  mode: OPEN_QUESTION_TREE_MODE.FLAT,
  currentQuestion: null,
  answeredQuestions: {},
  progress: {
    current: 0,
    total: 0,
    percent: 0
  },
  isKnockout: false,
  visibleQuestionIds: []
}

const mutations = {
  SET_MODE (state, mode) {
    state.mode = mode
  },
  SET_CURRENT_QUESTION (state, question) {
    state.currentQuestion = question || null
  },
  SET_ANSWER (state, answeredQuestions) {
    state.answeredQuestions = answeredQuestions || {}
  },
  SET_PROGRESS (state, progress) {
    state.progress = progress
  },
  SET_KNOCKOUT (state, isKnockout) {
    state.isKnockout = Boolean(isKnockout)
  },
  SET_VISIBLE_QUESTION_IDS (state, visibleQuestionIds) {
    state.visibleQuestionIds = visibleQuestionIds || []
  }
}

const actions = {
  hydrateTreeState ({ commit }, { questions, mode = OPEN_QUESTION_TREE_MODE.FLAT }) {
    const treeState = serializeQuestionTreeState(questions || [])
    commit('SET_MODE', mode)
    commit('SET_CURRENT_QUESTION', treeState.currentQuestion)
    commit('SET_ANSWER', treeState.answeredQuestions)
    commit('SET_PROGRESS', treeState.progress)
    commit('SET_KNOCKOUT', treeState.isKnockout)
    commit('SET_VISIBLE_QUESTION_IDS', treeState.visibleQuestionIds)
    return treeState
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
